<template>
    <div>
      <template v-if="openTabes && checkCurrentUrl">
        <div class="tab-inner-content">
          <div class="tabs-content-panel tab-pad-wrap">
                <div class="card-panels">
                  <vs-row vs-justify="center" >
                      <vs-col class="p-0" type="flex" vs-justify="center" vs-align="center" vs-w="12">
                        <div class="forms_letters"> 
                          <vs-tabs>
                              <vs-tab label="Documents" @click="changeTab('documentsList')" >
                                <template v-if="!editDocuments">
                                      <div class="main-list-wrap pad0">
                                        <div class="tab-inner-content">
                                          <div >
                                            <div class="doc_header pt-0 d" >
                                              <h3 class="small-header mart25">USA Company Documents</h3>
                                              <div class="d-flex" v-if="!loadedFromPreview">   
                                            
                                                <button v-if="checkNoNotifyUserIds && editableDocs && questionnaireDetails" @click="openEditDocs(true)" class="edit-doc"> <img src="@/assets/images/main/icon-edit.svg" />Upload Documents</button>
                                                <button v-if="checkCurrentUrl && allbtn && (todalDocumentsCount>0 || foreignDocsCount > 0 )" @click="downloadallfile()"  class="download_all">Download Documents</button>
                                                 <button v-if="is_enablesavebtn" @click="saveUploadedsFiles()" class="documents_save">Save</button>
                                              </div>
                                            </div>
                                            <template  v-if="todalDocumentsCount > 0">
                                                <div :key="docs" v-for="(type,docs) in  petitiondocuments" >
                                                  <!-- <div :key="index" v-for="(item,index) in  type" v-if="item.showMe==true"> -->
                                                      <vs-row v-if="type && (type.length > 0 || ((currentRole ==50 || currentRole == 51) && petition.documentsUploadEnabled )) && checkDocumentsExists(type) " >
                                                        <vs-col class="padl0 padr0">
                                                          <div class="card-panels pad0">
                                                            <vs-card>
                                                              <div slot="header" >
                                                                <h3>{{docs | formatdoctype}}</h3> 
                                                                
                                                                <div
                                                                  class="doc_upload upload_documents"
                                                                  @click="selectDoctype(docs)"
                                                                  v-if="(currentRole ==50|| currentRole == 51) && petition.documentsUploadEnabled && checkProperty(getPetitionDetails ,'status' )!=false"
                                                                >

                                                                  <file-upload
                                                                    v-model="profilePicture"
                                                                    class="file-upload-input"
                                                                    v-bind:name="docs"
                                                                    v-bind:data-vv-as="docs"
                                                                    :multiple="false"
                                                                    :accept="allDocEntity"
                                                                    @input="upload(profilePicture ,docs)"
                                                                  >
                                                                    <img class="file-icon" src="@/assets/images/main/file-upload.svg" /> Upload 
                                                                  </file-upload>
                                                                </div>
                                                              </div>
                                                              <div>
                                                                <div>
                                                                <template v-for="(item ,ind ) in  type" >
                                                              
                                                                  <div class="documents__list" v-if="checkProperty( item,'status') !=false" v-bind:key="ind">
                                                                    <div class="documents__title" @click="downloadfile(item)" >
                                                                      <figure > 
                                                                        <img v-if="checkFileFormat(item['mimetype']) =='pdf'" src="@/assets/images/main/pdf.svg" /> 
                                                                        <img v-else-if="checkFileFormat(item['mimetype']) =='video_mime_types'" src="@/assets/images/main/film.png" />
                                                                        <img v-else-if="checkFileFormat(item['mimetype']) =='msDoc'" src="@/assets/images/main/doc.svg" />
                                                                        <img v-else-if="checkFileFormat(item['mimetype']) =='zip'" src="@/assets/images/main/zip-file-format.png" />
                                                                        <img v-else-if="checkFileFormat(item['mimetype']) =='msPpt'" src="@/assets/images/main/ppt.svg" />
                                                                        <img v-else-if="checkFileFormat(item['mimetype']) =='msXl'" src="@/assets/images/main/xls.svg" />
                                                                        <img v-else-if="checkFileFormat(item['mimetype']) =='image'" src="@/assets/images/main/image.svg" />
                                                                        <img v-else src="@/assets/images/main/icon-img.svg" />
                                                                      </figure>
                                                                  
                                                                      <span >
                                                                        
                                                                        <em class="fl_scanned_docs" :title="item.name">{{item.name}}</em>
                                                                        <small class="uploaded_doc_small" v-if="!loadedFromPreview"> 
                                                                          <p><span v-if="getformated(item)"> {{ getformated(item) }}</span><span v-if="checkProperty(item,'uploadedByName')"> - Uploaded By {{ item['uploadedByName']}} <em v-if="checkProperty(item,'uploadedByRoleName')">({{ item['uploadedByRoleName'] }})</em></span></p>
                                                                        </small>                                                                        
                                                                      </span>
                                                                    </div>
                                                                    <div class="documents__actions d-flex">
                                                                      <button @click="removethis(ind ,type)" v-if="checkProperty( item, 'tempDoc')==true" class="view-btn ml-2">Remove</button>
                                                                      <button v-else @click="downloadfile(item,false,true)" class="view-btn ml-2">View</button>
                                                                      <button v-if="!loadedFromPreview && [50,51].indexOf(getUserRoleId)<=-1"  @click="confirmDocumentDelete(item,docs,ind,'UsaCompanyDocuments')" class="view-btn ml-2">Delete</button>
                                                                    </div>
                                                                  </div>
                                                                  </template>
                                                                </div>
                                                              </div>
                                                            </vs-card>
                                                          </div>
                                                        </vs-col>
                                                      </vs-row>
                                                  <!-- </div> -->
                                                </div> 
                                            </template>
                                            <NoDataFound ref="NoDataFoundRefu" :loading="processingDocuments"v-if="todalDocumentsCount <= 0"content=""
                                            :heading="'No Documents Found.'" type='documents' />
                                            <!-- <NoDataFound :checkLocading="processingDocuments" :loading="false" :update_loading="updateNodataLoading('NoDataRef')" :ref="'NoDataRef'"  content=""  heading="No Documents Found." type='documents'   v-if="todalDocumentsCount <= 0" /> -->
                                          </div>
                                          <div >
                                            <div class="doc_header pt-0 d" >
                                              <h3 class="small-header mart25">Foreign Company Documents</h3>                                            
                                            </div>
                                            <template  v-if="foreignDocsCount > 0">
                                                <div :key="docs" v-for="(type,docs) in  petitiondocumentr" >
                                                      <vs-row v-if="type && (type.length > 0 || ((currentRole ==50 || currentRole == 51) && petition.documentsUploadEnabled )) && checkDocumentsExists(type) " >
                                                        <vs-col class="padl0 padr0">
                                                          <div class="card-panels pad0">
                                                            <vs-card>
                                                              <div slot="header" >
                                                                <h3>{{docs | formatdoctype}}</h3> 
                                                                
                                                                <div
                                                                  class="doc_upload upload_documents"
                                                                  @click="selectDoctype(docs)"
                                                                  v-if="(currentRole ==50|| currentRole == 51) && petition.documentsUploadEnabled && checkProperty(getPetitionDetails ,'status' )!=false"
                                                                >

                                                                  <file-upload
                                                                    v-model="profilePicture"
                                                                    class="file-upload-input"
                                                                    v-bind:name="docs"
                                                                    v-bind:data-vv-as="docs"
                                                                    :multiple="false"
                                                                    :accept="allDocEntity"
                                                                    @input="upload(profilePicture ,docs)"
                                                                  >
                                                                    <img class="file-icon" src="@/assets/images/main/file-upload.svg" /> Upload 
                                                                  </file-upload>
                                                                </div>
                                                              </div>
                                                              <div>
                                                                <div>
                                                                <template v-for="(item ,ind ) in  type" >
                                                              
                                                                  <div class="documents__list" v-if="checkProperty( item,'status') !=false" v-bind:key="ind">
                                                                    <div class="documents__title" @click="downloadfile(item)" >
                                                                      <figure > 
                                                                        <img v-if="checkFileFormat(item['mimetype']) =='pdf'" src="@/assets/images/main/pdf.svg" /> 
                                                                        <img v-else-if="checkFileFormat(item['mimetype']) =='video_mime_types'" src="@/assets/images/main/film.png" />
                                                                        <img v-else-if="checkFileFormat(item['mimetype']) =='msDoc'" src="@/assets/images/main/doc.svg" />
                                                                        <img v-else-if="checkFileFormat(item['mimetype']) =='zip'" src="@/assets/images/main/zip-file-format.png" />
                                                                        <img v-else-if="checkFileFormat(item['mimetype']) =='msPpt'" src="@/assets/images/main/ppt.svg" />
                                                                        <img v-else-if="checkFileFormat(item['mimetype']) =='msXl'" src="@/assets/images/main/xls.svg" />
                                                                        <img v-else-if="checkFileFormat(item['mimetype']) =='image'" src="@/assets/images/main/image.svg" />
                                                                        <img v-else src="@/assets/images/main/icon-img.svg" />
                                                                      </figure>
                                                                  
                                                                      <span >
                                                                        
                                                                        <em class="fl_scanned_docs" :title="item.name">{{item.name}}</em>
                                                                        <small class="uploaded_doc_small" v-if="!loadedFromPreview"> 
                                                                          <p><span v-if="getformated(item)"> {{ getformated(item) }}</span><span v-if="checkProperty(item,'uploadedByName')"> - Uploaded By {{ item['uploadedByName']}} <em v-if="checkProperty(item,'uploadedByRoleName')">({{ item['uploadedByRoleName'] }})</em></span></p>
                                                                        </small>                                                                        
                                                                      </span>
                                                                    </div>
                                                                    <div class="documents__actions d-flex">
                                                                      <button @click="removethis(ind ,type)" v-if="checkProperty( item, 'tempDoc')==true" class="view-btn ml-2">Remove</button>
                                                                      <button v-else @click="downloadfile(item,false,true)" class="view-btn ml-2">View</button>
                                                                      <button v-if="!loadedFromPreview && [50,51].indexOf(getUserRoleId)<=-1"  @click="confirmDocumentDelete(item,docs,ind,'ForeignCompanyDocuments')" class="view-btn ml-2">Delete</button>
                                                                    </div>
                                                                  </div>
                                                                  </template>
                                                                </div>
                                                              </div>
                                                            </vs-card>
                                                          </div>
                                                        </vs-col>
                                                      </vs-row>
                                                  <!-- </div> -->
                                                </div> 
                                            </template>
                                            <NoDataFound ref="NoDataFoundReforeign" :loading="processingDocuments"v-if="foreignDocsCount <= 0"content=""
                                            :heading="'No Documents Found.'" type='documents' />
                                            <!-- <NoDataFound :checkLocading="processingDocuments" :loading="false" :update_loading="updateNodataLoading('NoDataRef')" :ref="'NoDataRef'"  content=""  heading="No Documents Found." type='documents'   v-if="foreignDocsCount <= 0" /> -->
                                          </div>
                                        </div>
                                      </div>
                                 </template>
                                 <template v-else> 
                                    <div class="main-list-wrap sdgf pad0 editCaseDocuments  doc__list rfe_petition_docs">
                                      <documentsUploadcomp v-if="editDocuments" :petition="petition" :fieldsArray="fieldsArray" :questionnaireDetails="questionnaireDetails" :showSpouseDocs="false" 
                                      @reloadCaseDetails="reloadCaseDetails"  @openEditDocs="openEditDocs"  :callFromPetitionerDocs="true" :spouseDocumentList="[]" :benDocumentList="[]"  />
                                    </div>
                              </template>
                              </vs-tab>
                          </vs-tabs>   
                        </div>
                      </vs-col>
                  </vs-row>
              </div>
          </div>
        </div>
      </template>
      <template v-else>
          <template v-if="!editDocuments">
            <div class="main-list-wrap" >
                  <div class="tab-inner-content pad0 pt-0 pb-2">
                    <div class="doc_top_bar" v-if="documentsUploadbtn && false">
                      <p>(File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)</p>

                          <template v-if="false&&[5,7,8,6].indexOf(currentRole) >- 1 && petition.statusId < 11" >
                      <div
                      
                        v-show="!petition.documentsUploadEnabled"
                        class="documents_toggle"
                        @click="checker(false)"
                      >
                        <label>Unlock Documents</label>
                        <figure>
                          <img src="@/assets/images/main/unlock.svg" />
                        </figure>
                      </div>

                      <div
                        v-show="petition.documentsUploadEnabled && petition.statusId < 11"
                        class="documents_toggle"
                        @click="checker(true)"
                      >
                        <label>Lock Documents</label>
                        <figure>
                          <img src="@/assets/images/main/lock.svg" />
                        </figure>
                      </div>
                          </template>
                    </div>              
                    <div :class="{'pad20':!checkCurrentUrl}" >
                      <div class="doc_header pt-0" >
                        <h3 class="small-header mart25"  >
                        <template  v-if="todalDocumentsCount>0">
                          USA Company Documents
                        </template>
                        </h3>
                        
                        <div class="d-flex">  
                           <button v-if=" ( !loadedFromPreview && checkCurrentUrl  ) && checkNoNotifyUserIds && editableDocs && questionnaireDetails" @click="openEditDocs(true)" class="edit-doc"> <img src="@/assets/images/main/icon-edit.svg" />Upload Documents</button>        
                          <button v-if="!callBenDetails && [50].indexOf(getUserRoleId)<=-1 && checkCurrentUrl && allbtn && (todalDocumentsCount>0 || foreignDocsCount>0 || totalChildDocumentCount>0 )" @click="downloadallfile()" class="download_all">Download Documents </button>
                          <button v-if="is_enablesavebtn" @click="saveUploadedsFiles()" class="documents_save">Save</button>
                        </div>
                        
                      </div>
                        <template  v-if="todalDocumentsCount>0">
                      <div :key="docs" v-for="(type,docs) in  petitiondocuments">
                        
                        <vs-row v-if="docs !='beneficiaryDocs' && type && (type.length > 0 || ((currentRole ==50 || currentRole == 51) && petition.documentsUploadEnabled )) && checkDocumentsExists(type) " >
                          <vs-col class="padl0 padr0">
                            <div class="card-panels pad0">
                              <vs-card>
                                <div slot="header" >
                                  <h3>{{docs | formatdoctype}}</h3> 
                                  <div
                                    class="doc_upload upload_documents"
                                    @click="selectDoctype(docs)"
                                    v-if="(currentRole ==50|| currentRole == 51) && petition.documentsUploadEnabled && checkProperty(getPetitionDetails ,'status' )!=false"
                                  >

                                    <file-upload
                                      v-model="profilePicture"
                                      class="file-upload-input"
                                      v-bind:name="docs"
                                      v-bind:data-vv-as="docs"
                                      :multiple="false"
                                      :accept="allDocEntity"
                                      @input="upload(profilePicture ,docs)"
                                    >
                                      <img class="file-icon" src="@/assets/images/main/file-upload.svg" /> Upload 
                                    </file-upload>
                                  </div>
                                </div>
                                <div>
                                  <div>
                                    <template v-for="(item ,ind ) in  type">
                                
                                      <div class="documents__list" v-if="checkProperty( item,'status') !=false"  v-bind:key="ind">
                                        <div class="documents__title" @click="downloadfile(item)">
                                          <figure> 
                                            <img v-if="checkFileFormat(item['mimetype']) =='pdf'" src="@/assets/images/main/pdf.svg" /> 
                                            <img v-else-if="checkFileFormat(item['mimetype']) =='video_mime_types'" src="@/assets/images/main/film.png" />
                                            <img v-else-if="checkFileFormat(item['mimetype']) =='msDoc'" src="@/assets/images/main/doc.svg" />
                                            <img v-else-if="checkFileFormat(item['mimetype']) =='zip'" src="@/assets/images/main/zip-file-format.png" />
                                            <img v-else-if="checkFileFormat(item['mimetype']) =='msPpt'" src="@/assets/images/main/ppt.svg" />
                                            <img v-else-if="checkFileFormat(item['mimetype']) =='msXl'" src="@/assets/images/main/xls.svg" />
                                            <img v-else-if="checkFileFormat(item['mimetype']) =='image'" src="@/assets/images/main/image.svg" />
                                            <img v-else src="@/assets/images/main/icon-img.svg" />
                                          </figure>
                                          <span>
                                            <!-- {{item.name}} -->
                                            <em class="fl_scanned_docs" :title="item.name">{{item.name}}</em>
                                            <small class="uploaded_doc_small" v-if="!loadedFromPreview"> 
                                              <p><span v-if="getformated(item)"> {{ getformated(item) }}</span><span v-if="checkProperty(item,'uploadedByName')"> - Uploaded By {{ item['uploadedByName']}} <em v-if="checkProperty(item,'uploadedByRoleName')">({{ item['uploadedByRoleName'] }})</em></span></p>
                                            </small>
                                          
                                          </span>
                                        </div>
                                        <div class="documents__actions d-flex">
                                          <button @click="removethis(ind ,type)" v-if="checkProperty( item, 'tempDoc')==true" class="view-btn ml-2">Remove</button>
                                          <button v-else @click="downloadfile(item,false,true)" class="view-btn ml-2">View</button>
                                          <button v-if="!loadedFromPreview && ['Child','Spouse'].indexOf(callFrom)>-1 && [50,51].indexOf(getUserRoleId)<=-1" @click="confirmDocumentDelete(item,docs,ind,'UsaCompanyDocuments')" class="view-btn ml-2">Delete</button>
                                        </div>
                                      </div>
                                    </template>
                                  </div>
                                </div>
                              </vs-card>
                            </div>
                          </vs-col>
                        </vs-row>
                      </div>
                        </template>
                        <NoDataFound :loading="false" :checkLocading="processingDocuments" ref="NoDataRef"  :update_loading="updateNodataLoading()"   content=""  heading="No Documents Found." type='documents'   v-if="todalDocumentsCount<=0 "/>
                      <!------------Spouse Documents spouseActiveDocs-------->             
                      <template  v-if="  checkProperty(petition,'petitionerQuestInfo' ,'foreignCompanyDocuments') && Object.entries(petitiondocumentr).length>0" >
                        <div class="doc_header pt-0 d"  >
                          <h3 class="small-header mart25" >Foreign Company Documents</h3>
                        </div>
                        <div :key="docs" v-for="(type,docs) in  petitiondocumentr">
                        <vs-row v-if="docs !='beneficiaryDocs' && type && (type.length > 0 || ((currentRole ==50 || currentRole == 51) && petition.documentsUploadEnabled )) && checkDocumentsExists(type) " >
                          <vs-col class="padl0 padr0">
                            <div class="card-panels pad0">
                              <vs-card>
                                <div slot="header" >
                                  <h3>{{docs | formatdoctype}}</h3> 
                                  <div
                                    class="doc_upload upload_documents"
                                    @click="selectDoctype(docs)"
                                    v-if="(currentRole ==50|| currentRole == 51) && petition.documentsUploadEnabled && checkProperty(getPetitionDetails ,'status' )!=false"
                                  >

                                    <file-upload
                                      v-model="profilePicture"
                                      class="file-upload-input"
                                      v-bind:name="docs"
                                      v-bind:data-vv-as="docs"
                                      :multiple="false"
                                      :accept="allDocEntity"
                                      @input="upload(profilePicture ,docs)"
                                    >
                                      <img class="file-icon" src="@/assets/images/main/file-upload.svg" /> Upload 
                                    </file-upload>
                                  </div>
                                </div>
                                <div>
                                  
                                  <template v-for="(item ,ind ) in  type" >
                                    <div class="documents__list" v-if="checkProperty( item,'status') !=false" v-bind:key="ind">
                                      <div class="documents__title" @click="downloadfile(item)">
                                        <figure> 
                                          <img v-if="checkFileFormat(item['mimetype']) =='pdf'" src="@/assets/images/main/pdf.svg" /> 
                                          <img v-else-if="checkFileFormat(item['mimetype']) =='video_mime_types'" src="@/assets/images/main/film.png" />
                                          <img v-else-if="checkFileFormat(item['mimetype']) =='msDoc'" src="@/assets/images/main/doc.svg" />
                                          <img v-else-if="checkFileFormat(item['mimetype']) =='zip'" src="@/assets/images/main/zip-file-format.png" />
                                          <img v-else-if="checkFileFormat(item['mimetype']) =='msPpt'" src="@/assets/images/main/ppt.svg" />
                                          <img v-else-if="checkFileFormat(item['mimetype']) =='msXl'" src="@/assets/images/main/xls.svg" />
                                          <img v-else-if="checkFileFormat(item['mimetype']) =='image'" src="@/assets/images/main/image.svg" />
                                          <img v-else src="@/assets/images/main/icon-img.svg" />
                                        </figure>
                                        <span>
                                          <!-- {{item.name}} -->
                                          <em class="fl_scanned_docs" :title="item.name">{{item.name}}</em>
                                          <small class="uploaded_doc_small" v-if="!loadedFromPreview"> 
                                            <p><span v-if="getformated(item)"> {{ getformated(item) }}</span><span v-if="checkProperty(item,'uploadedByName')"> - Uploaded By {{ item['uploadedByName']}} <em v-if="checkProperty(item,'uploadedByRoleName')">({{ item['uploadedByRoleName'] }})</em></span></p>
                                          </small>
                                        </span>
                                      </div>
                                      <div class="documents__actions">
                                        <button @click="removethis(ind ,type)" v-if="checkProperty( item, 'tempDoc')==true" class="view-btn">Remove</button>
                                        <button v-else @click="downloadfile(item,false,true)" class="view-btn">View</button>
                                        <button v-if="!loadedFromPreview && ['Child','Spouse'].indexOf(callFrom)>-1 && [50,51].indexOf(getUserRoleId)<=-1" @click="confirmDocumentDelete(item,docs,ind,'ForeignCompanyDocuments')" class="view-btn ml-2">Delete</button>
                                      </div>
                                    </div>
                                    </template> 
                                </div>
                              </vs-card>
                            </div>
                          </vs-col>
                        </vs-row>
                      </div>
                        
                      </template>

                      <!-----------Children Documents---------->

                      <NoDataFound :loading="false" :checkLocading="processingDocuments" ref="NoDataRef"  :update_loading="updateNodataLoading()"   content=""  heading="No Documents Found." type='documents'   v-if=" foreignDocsCount <=0"/>
                    </div>
                  </div>
            </div>
          </template>
          <template v-else> 
            <template>
              <documentsUploadcomp v-if="editDocuments" :petition="petition" :fieldsArray="fieldsArray" :questionnaireDetails="questionnaireDetails" :showSpouseDocs="false" 
                @reloadCaseDetails="reloadCaseDetails"  @openEditDocs="openEditDocs"  :callFromPetitionerDocs="true" :spouseDocumentList="[]" :benDocumentList="[]" />
              <!-- <documentsUploadcomp v-if="editDocuments" :petition="petition" :questionnaireDetails="questionnaireDetails" @reloadCaseDetails="reloadCaseDetails"  @openEditDocs="openEditDocs" /> -->
            </template>
            <!-- <template v-else>
              <div class="main-list-wrap pad0 editCaseDocuments dd ">
                <caseQuestionnaireDocs @downloadOrView="downloadfile" v-if="editDocuments"  :petitionDetails="petition" 
                 :questionnaireDetails="questionnaireDetails"  @reloadCaseDetails="reloadCaseDetails" :tempDocuments="sponsorDocuments" :callFromEdit='true' @openEditDocs="openEditDocs" />
              </div>   
            </template> -->
               
          </template>
      </template>
       
       <vs-popup class="Change_petition_wrap" :title="'Upload Documents'" :active.sync="fileuploadPopup">
            <div class="Change_petition" @click="formerrors.msg=''">
                <div class="vx-col w-full marb10">
                  <fileUploadNote :fileNote="true" />
                    
                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <vx-input-group class="form-input-group select-upload-group">
                                    <div class="uploadsec_wrap">
                                        <div class="w-full">
    
                                            <div  @click="uploadMainDocuments=[]">
                                                <file-uploadd v-model="uploadMainDocuments" 
                                                :accept="allDocEntity"  :emitCategory="'pdocuments'"  @updateData="updateData" :fieldName="'pdocuments'"  :cid="'pdocuments'"
                                                 class="file-upload-input mb-0" style="height:50px; padding:0px;" :name="'pdocuments'" :multiple="true" :hideSelected="true" v-validate="'required'" label="Forms and Letters" data-vv-as="Forms and Letters"  >
                                                    <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                                                   
                                                    Upload 
                                                </file-uploadd>
                                                <span class="file-type">(File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)</span>
                                                <span v-if="[50,51].indexOf(getUserRoleId)>-1" class="text-danger text-sm" v-show="errors.has('pdocuments')">*Documents are required</span>
                                                <span v-else class="text-danger text-sm" v-show="errors.has('pdocuments')">{{ errors.first('pdocuments') }}</span>
                                            </div>
    
                                            <VuePerfectScrollbar class="scrollbardoc">
                                                <div class="uploded-files_wrap" v-if="uploadFinalMainDocuments && uploadFinalMainDocuments.length >0 ">
                                                    <div class="w-full" v-for="(fil, fileindex) in uploadFinalMainDocuments" :key="fileindex">
                                                       
                                                        <div class="uploded-files">
                                                            <vx-input-group class="form-input-group">
                                                                <vs-input v-on:keyup="filameChenged(fileindex)"  v-validate="'required'" class="w-full" :name="'fName'+fileindex" v-model="fil['name']" data-vv-as="File Name" />
                                                                <span class="text-danger text-sm" v-show="errors.has('fName'+fileindex)">{{ errors.first('fName'+fileindex) }}</span>
    
                                                                <div class="delete"  @click="remove(fil, uploadFinalMainDocuments ,fileindex)">
                                                                    <img src="@/assets/images/main/cross.svg" />
                                                                </div>
                                                            </vx-input-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </VuePerfectScrollbar>
                                        </div>
                                    </div>
                                </vx-input-group>
                            </div>
                        </div>
                    
                </div>
            </div>
            
             <div class="text-danger text-sm formerrors" v-show="formerrors.msg" @click="formerrors.msg=''">
                <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                  icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
              </div>
            <div  class="popup-footer relative" >
                <button @click="fileuploadPopup=false; fuploder=false" class="btn cancel">Cancel</button>
                <button class="btn save" v-bind:disble="disable_uploadBtn || uploadFinalMainDocuments.length<=0" @click="uploadBenDocuments()">
                    <figure v-if="fuploder" class="loader loader2"><img src="@/assets/images/main/loader.gif" /></figure>
                    Upload
                </button>
            </div>
        </vs-popup>
    
        <div  class="custom_modal_sec documents__modal custom_modal-v2" :class="{ modalopen: downloadDocList }" >
          <div class="custom_modal_overlay"   ></div>
            <div class="custom_modal_cnt">
              <div class="modal_title">      
                <h2> Download Documents </h2>                
                <span class="close" @click="$emit('closeMe');downloadDocList = false"><x-icon size="1.5x"></x-icon></span>
              </div>
              <petitionerDocsDownload @closeMe="downloadDocList=false" v-if="!loadedFromPreview && downloadDocList" @downloadfile="downloadfile" v-bind:petition="petition" v-bind:loadedFromPreview="loadedFromPreview" />
          </div>
        </div>
        <vs-popup class="holamundo main-popup cls-btn" title="Delete Document" :active.sync="showDocumentDeletePopup">
                <div class="form-container">
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <p style="line-height: 20px">
                              Do you want to Delete?
                            </p>
                        </div>
                    </div>
                </div>
                <div class="popup-footer">
                    <vs-button color="dark" class="cancel" type="filled" @click="showDocumentDeletePopup = false;cancelDocumentDel()">Cancel</vs-button>
                    <vs-button @click="documentDelete();" class="save questionnaire_btn" type="filled">Delete </vs-button>
                </div>
        </vs-popup>
    </div>
    </template>
 <style >
    .dragHead {
      background: #eceff3;
      border-radius: 4px 4px 0 0;
      padding: 6px 10px;
      color: #1d202c;
      font-size: 14px;
      font-family: "robotomedium";
      line-height: normal;
    }
    
    .subdragHead {
      padding: 6px 10px;
      color: #1d202c;
      font-size: 14px;
      font-family: "robotomedium";
      line-height: normal;
    }
    .dragNested {
      padding: 10px 20px;
    }
    .scrollbardoc {
      height: 400px;
    }
    </style>
   <script>
    import docType from "@/views/common/docType.vue";
    import fileUploadNote from "@/views/common/fileUploadNote.vue";
    
    import moment, { relativeTimeThreshold } from "moment";
    import casedocumentslist from "@/views/common/casedocuments.vue";
    import * as _ from "lodash";
    import draggable from "vuedraggable";
    import VuePerfectScrollbar from "vue-perfect-scrollbar";
    import NoDataFound from "@/views/common/noData.vue";
      import { XIcon } from 'vue-feather-icons'
    import FileUpload from "vue-upload-component/src";
    import documentsUploadcomp from "@/views/forms/documentsUpload.vue";
    import caseQuestionnaireDocs from "@/views/forms/caseQuestionnaireDocs.vue";
    import downLoadCaseDocuments from "@/views/petition/downLoadCaseDocuments.vue";
    import petitionerDocsDownload from "@/views/petition/lvisaDetails/petitionerDocsDownload.vue";
    import Vue from 'vue';
    Vue.use( CKEditor );
    import CKEditor from '@ckeditor/ckeditor5-vue2';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import JQuery from "jquery";
    import { formatDate } from "tough-cookie";
    import FileUploadd from "@/views/FileUpload.vue";
    export default {
       provide() {
            return {
                parentValidator: this.$validator,
            };
        },
      components: {
        FileUploadd,
        fileUploadNote,
        documentsUploadcomp,
        downLoadCaseDocuments,
        petitionerDocsDownload,
        caseQuestionnaireDocs,
        draggable,
        FileUpload,
        VuePerfectScrollbar,
        NoDataFound,
        casedocumentslist,
        XIcon,
        docType
      },
      data() {
        return {
          petitionDetail:null,

          petitionerDocsList:[
          {
                        required: false,
                        fileUploading:false,
                        key: 'markMetOrWebsitePrints',
                        fieldName: 'markMetOrWebsitePrints',
                        label: 'Marketing materials/website printouts'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'goodStandCert',
                        fieldName: 'goodStandCert',
                        label: 'Good standing certificate'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'articleOfIncorp',
                        fieldName: 'articleOfIncorp',
                        label: 'Articles of Incorporation'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'stateRegCert',
                        fieldName: 'stateRegCert',
                        label: 'State Registration Certificate'
                    },
                ],
          
          
          selectedDocObj:null,
          selectedDocCategory:'',
          selectedDocIndex:null,
          selectedPetitionCategory:'',
          showDocumentDeletePopup:false,
          acceptDocs:[],
          documensUpdating:false,
          offerDocuments:{
            slgOfferLetter:[],
            slgSignedOfferLetter:[],
          },
         
          allChildrens:[],
          testVariable:[],
          childsObject:[],
          benChildsObject:[],
          showConetent1:false,
          showConetent2:false,
          showConetent3:false,
          editor: ClassicEditor,
          editorConfig: {
              toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
          },
          savedDocumentsList:[],
          isDocumentsAreSaved:false,
          documentActiveTab:'savedDocuments',
          editDocuments:false,
           sponsorDocuments: {
                passport:[],
                greenCard:[],
                birthCertificate:[],
                photographs:[],
          },
          
          itemSlength:0,
           downloadDocList: false,
           acceptedFiles:'application/pdf',
          filesDownloading:false,
          lockUnlockformerrors:'',
          color: "#000",
          downloadDocumentPop: false,
          documentsUpload: true,
          lockDocumentsPopup: false,
          lockDocumentsPopupTitle: "",
          uploaddocType: "",
          profilePicture: [],
          petitiondocuments: {},
          
          petitiondocumentsl: [],
          petitiondocumentr: [],
          childernDocuments:[],
          is_enablesavebtn: false,
    
          errorMessage:'',
          fileuploadPopup:false,
          documentUploaded:[],
          activeTabName:'Documents',
          disable_uploadBtn:false,
          fuploder:false,
           formerrors: {
            msg: ""
          },
          selectedDocsForApprove:[],
          selectAll:false,
          uploadMainDocuments:[],
          uploadFinalMainDocuments:[],
    
          todalDocumentsCount:0,
          foreignDocsCount:0,
          totalChildDocumentCount:0,
          spouseActiveDocs:[],
          questionnaireDetails:null,
          tempUpdateDocList:{
            "benficiaryCategoryOrders":[], //[{ category:'resumes' ,order:1}]
            "spouseCategoryOrders":[], //[{ category:'resumes' ,order:1}]
            "childCategoryOrders":[], //[{ category:'resumes' ,order:1 ,"childrenId":'' }]
             "documentsOrder":[ ] //[{'path':'http://s3.amozon.com' ,order:2}]
          },
          benficiaryTrashItems:[],
          trashedItems:[],
          processingDocuments:false
    
          
    
        };
      },
      watch: {
        documentsUpload: function (value) {},
      },
      props: {
        loadedFromPreview:{type: Boolean , default: false},
        editableDocs:{type: Boolean , default: false},
        openTabes:false,
        allbtn: false,
        documentsUploadbtn: false,
        currentRole: null,
        petition: {
          type: Object,
          default: null,
        },
        workFlowDetails: {
          type: Object,
          default: null,
        },
        fieldsArray:[],
        callBenDetails:{
          type:Boolean,
          default:false
        },
        callFrom:{
          type:String,
          default:''
        },
        petitionId:{
          type:String,
          default:''
        }
      },
      mounted() {
        this.getSavedDocuments();
        let self =this;
        //this.modifySponsorDocs();
        setTimeout(()=>{
          if (_.has(this.petition, "questionnaireTplId")) {
    
         
          this.questionnaireTplId = this.getPetitionDetails["questionnaireTplId"];
          this.getquestionnaireDetails();
        }
        });
          //this.initDocuments();
        
      },
      methods: {
        modifySponsorDocs(){
          let petitionDetail= _.cloneDeep(this.petition)
          if(this.checkProperty(this.petition, 'petitionerQuestInfo') && this.checkProperty(this.petition, 'petitionerQuestInfo', 'usaCompanyDocuments')){
            petitionDetail['documents'] = this.checkProperty(this.petition, 'petitionerQuestInfo', 'usaCompanyDocuments');
          }
          this.petitionDetail = _.cloneDeep(petitionDetail)
        },
        updateData(docs, category){
         
          if(category == 'pdocuments'){
            this.uploadFinalMainDocuments = docs
          }
         
        },
        fetchSignedUrl(value, download = false, viewmode = true) {
         
         value.download = download;
         
         if( !_.has(value ,'viewmode')){
           value.viewmode = viewmode;
         }
         this.$emit("download_or_view", value);
         // window.open(this.$globalgonfig._APIURL+"/common/viewfile?path="+value.path, "_blank");
       },
       download_or_view(value) {
           
           if (_.has(value, "path")) {
               value['url'] = value['path'];
               value['document'] = value['path'];
           }
    
           if (_.has(value, "url")) {
               value['path'] = value['url'];
               value['document'] = value['url'];
           }
    
           if (_.has(value, "document")) {
               value['path'] = value['document'];
               value['url'] = value['document'];
           }
           
    
           this.selectedFile = value;
           this.docValue = '';
           this.docPrivew = false;
           this.docType = false;
           this.docType = this.findmsDoctype(value);
    
           if (false && (this.docType == "office" || this.docType == "image")) {
    
               value.url = value.url.replace(this.$globalgonfig._S3URL, "");
               value.url = value.url.replace(this.$globalgonfig._S3URLAWS, "");
               let postdata = {
                   keyName: value.url
               };
               this.$store.dispatch("getSignedUrl", postdata).then((response) => {
                   this.docValue = response.data.result.data;
    
                   if (this.docType == "office") {
                       this.docValue = encodeURIComponent(response.data.result.data);
                   }
                   this.docPrivew = true;
               });
    
           } else {
    
               this.downloads3file(value);
           }
    
       },
        confirmDocumentDelete(document,docCategory,inde,category,childId){
          this.selectedDocObj = document;
          this.selectedDocCategory = docCategory;
          this.selectedDocIndex = inde;
          this.selectedPetitionCategory = category;
          this.showDocumentDeletePopup = true;
        },
        cancelDocumentDel(){
          this.selectedDocObj = null;
          this.selectedDocCategory = '';
          this.selectedDocIndex = null;
          this.selectedPetitionCategory = '';
          this.showDocumentDeletePopup = false;
        },
        documentDelete(){
          let selectedDocument = this.selectedDocObj;
          let selectedDocCategory = this.selectedDocCategory;
          let selectedChild = this.selectedDocIndex;
          let selectedPetitionCategory = this.selectedPetitionCategory;
          if(selectedDocument){
            selectedDocument = Object.assign(selectedDocument ,{ 'docTypeName':''})
          }
          let payLoad={
            petitionId: this.checkProperty(this.petition,'_id'),
            documents:null,
            deletedDocs:null,
            entityType:'case'
          };
          let tempDocs = null;
          if(selectedPetitionCategory == 'ForeignCompanyDocuments' || selectedPetitionCategory == 'UsaCompanyDocuments' ){
            selectedDocument['docTypeName'] = this.formatDocLabel(selectedDocCategory);
            payLoad['category'] = selectedPetitionCategory;
            let tempCategory = 'usaCompanyDocuments'
            if(selectedPetitionCategory == 'ForeignCompanyDocuments'){
              tempCategory = 'foreignCompanyDocuments'
            }
            tempDocs = this.checkProperty(this.petition, 'petitionerQuestInfo', tempCategory);
            if(_.has(tempDocs, selectedDocCategory) && this.checkProperty(tempDocs,selectedDocCategory,'length')>0 && _.has(selectedDocument,'path')){
              let filteredDoc = _.filter(tempDocs[selectedDocCategory],(docItem)=>{
                return docItem['path'] != selectedDocument['path']
              })
              tempDocs[selectedDocCategory] = filteredDoc;
            }
            tempDocs = _.cloneDeep(tempDocs)
          };

          payLoad['documents'] = _.cloneDeep(tempDocs);
          payLoad['deletedDocs'] = _.cloneDeep(selectedDocument);
          let path = '/petition-common/delete-document';
          this.$store.dispatch('commonAction',{data:payLoad,'path':path}).then((res)=>{
            this.cancelDocumentDel();
            this.showToster({message:res.message,isError:false });
            this.init();
          }).catch((err)=>{
    
          })
        },
        initDocuments(){
        //   this.acceptDocs =[];
        //  _.filter(this.petition.petitionerQuestInfo.documents ,(item)=>{
        //       item['accepted'] =false
        //       this.acceptDocs.push(item)
            
        //  })
        },
        
        getformated(item) {
    
           if(item.uploadedOn){
                return (
                "Uploaded On  " +
                moment(item.uploadedOn).format("MMM DD, YYYY hh:mm:ss a")
              );
            }
            else {
            if( item.createdOn){
                  return (
                  "Uploaded On  " +
                  moment(item.createdOn).format("MMM DD, YYYY hh:mm:ss a")
              );
    
            }
          }
        },
        openEditDocs(action =false){
            this.sponsorDocuments={
                passport:[],
                greenCard:[],
                birthCertificate:[],
                photographs:[],
            }
            let documents = _.cloneDeep(this.sponsorDocuments);
            if(this.checkProperty(this.petition['petitionerQuestInfo'] ,'usaCompanyDocuments')){
              _.forEach(Object.entries(this.petition['petitionerQuestInfo']['usaCompanyDocuments']) ,(val ,key)=>{
                if(this.checkProperty( val ,"length")>1){  
                  let docKey = val[0]; 
                let docs = val[1];
                _.forEach(docs  ,(dcoItem)=>{
                  dcoItem['isNew'] =false
                })
                documents[docKey] = docs;
                }
              })
            }
            this.sponsorDocuments =null;
            this.sponsorDocuments = _.cloneDeep(documents);
            this.sponsorDocuments = _.cloneDeep(this.sponsorDocuments);
            
            if(action){
              setTimeout(()=>{
                this.editDocuments =true;
              });
            }else{
              //this.editDocuments = false;
              this.$emit("updatepetition" ,'petitionerDocs');
              this.$store.dispatch("setPetitionTab", 'petitionerDocs')
              
              //this.$emit("updatepetition" ,'petitionerDocs');
            }
        },
        
    
        splitFiles(){
    
          this.processingDocuments =true;
          this.petitiondocuments ={};
          let self =this;
          let total = Object.entries(this.petition.petitionerQuestInfo.usaCompanyDocuments).length;
          let half = Math.round(total/2);
           this.todalDocumentsCount = 0;
           this.foreignDocsCount = 0;
           this.totalChildDocumentCount =0;
           this.petitiondocumentr ={};
           let tempDocs =  _.cloneDeep(this.petition.petitionerQuestInfo.usaCompanyDocuments);
           this.updateLoading(true, 'NoDataFoundRefu');
           this.updateLoading(true, 'NoDataFoundReforeign');
            let caseDocuments =_.cloneDeep(tempDocs );
              _.forEach(
              Object.entries(caseDocuments ),
              (item ,index)=> {
                
                  if( this.checkProperty(item  ,'length')>1){
                  if( this.checkProperty(item[1] ,'length')>0){
                    let documentCategory =item[0];
    
                      let activeRecords = [];
                      _.forEach(item[1] ,(doc)=>{
                         Object.assign(doc ,{'isTrashDocument':false})  
                        if(this.getUserRoleId == 51 || this.IsSponsorLogin){
                            if(!this.IsSponsorLogin && this.checkProperty(doc,'uploadedByRoleId') && this.checkProperty(doc,'uploadedByRoleId') == 51 ){
                              Object.assign(doc ,{'showMe':true}) 
                            }
                            else if(this.getUserRoleId == 51 && this.IsSponsorLogin){
                              Object.assign(doc ,{'showMe':false}) 
                            }else{
                              Object.assign(doc ,{'showMe':false}) 
                            }
                        }
                         else{
                              Object.assign(doc ,{'showMe':true})  
                           }
                        doc['isTrashDocument'] =false;
                        if(this.isDocumentsAreSaved  ){
                            let isSavedDoc = _.find(this.savedDocumentsList ,{'path':doc['path']});                           
                                if(!isSavedDoc){                            
                                    doc['isTrashDocument'] =true;                      
                                }
                        }
                        if(doc.status && ( this.checkProperty( doc ,'path') !='' || this.checkProperty( doc ,'url') !=''  )){
                          if(this.getUserRoleId == 51 && !this.IsSponsorLogin  ){
                            if(this.checkProperty(doc,'uploadedByRoleId') == 51 && doc.showMe==true){
                              activeRecords.push(doc)
                            }
                          }
                          else if(this.getUserRoleId == 51 && this.IsSponsorLogin){
                            activeRecords.push( _.cloneDeep(doc));
                          }
                          else{
                            activeRecords.push( _.cloneDeep(doc));
                          }
                        
                        }
    
                      })
                      
                      if(activeRecords.length>0){
                        this.petitiondocuments[documentCategory] =[];
                        this.petitiondocuments[documentCategory] =_.cloneDeep(activeRecords);
                        this.todalDocumentsCount = this.todalDocumentsCount +(activeRecords.length);
                       
                      
                      }
                     
                     
                    
              }
              }
                    
              });
              this.updateLoading(false, 'NoDataFoundRefu');
            if(this.checkProperty( this.petition,'petitionerQuestInfo' ,'foreignCompanyDocuments')){
              if(this.checkProperty( this.petition['petitionerQuestInfo'] ,'foreignCompanyDocuments')){
                _.forEach(
                  Object.entries(this.petition['petitionerQuestInfo']['foreignCompanyDocuments']),
                  (item ,index)=> {
                    
                      if( this.checkProperty(item  ,'length')>1){
                      if( this.checkProperty(item[1] ,'length')>0){
                        let documentCategory =item[0];

                          let activeRecords = [];
                          _.forEach(item[1] ,(doc)=>{
                            if(!this.checkCurrentUrl){
                              if(this.checkProperty(doc,'uploadedBy') && this.checkProperty(this.getUserData , 'userId')){
                                if(this.checkProperty(doc,'uploadedBy') == this.checkProperty(this.getUserData , 'userId')){
                                  Object.assign(doc ,{'showMe':true}) 
                                }else{
                                  Object.assign(doc ,{'showMe':false}) 
                                }
                              }
                            }else{
                              if(this.getUserRoleId == 51){
                                if(this.checkProperty(doc,'uploadedByRoleId') && this.checkProperty(doc,'uploadedByRoleId') == 51 ){
                                  Object.assign(doc ,{'showMe':true}) 
                                }else{
                                  Object.assign(doc ,{'showMe':false}) 
                                }
                              } else{
                                Object.assign(doc ,{'showMe':true})  
                              }
                            }
                            
                            doc['isTrashDocument'] =false;
                            if(this.isDocumentsAreSaved  ){
                                let isSavedDoc = _.find(this.savedDocumentsList ,{'path':doc['path']});
                              if(!isSavedDoc){
                                  doc['isTrashDocument'] =true;

                              }

                            }
                            if(doc.status && ( this.checkProperty( doc ,'path') !='' || this.checkProperty( doc ,'url') !=''  )){
                              if(!this.checkCurrentUrl){
                                if(this.checkProperty(doc,'uploadedBy') && this.checkProperty(this.getUserData , 'userId') && (this.checkProperty(doc,'uploadedBy') == this.checkProperty(this.getUserData , 'userId')) ){
                                  activeRecords.push(doc)
                                }
                              }else{
                                if(this.getUserRoleId == 51 ){
                                  if(this.checkProperty(doc,'uploadedByRoleId') == 51 && doc.showMe==true){
                                    activeRecords.push(doc)
                                  }
                                }else{
                                  activeRecords.push( _.cloneDeep(doc));
                                }
                              }
                              
                            }
                          })
                          
                          if(activeRecords.length>0){
                            this.petitiondocumentr[documentCategory] =[];
                            this.petitiondocumentr[documentCategory] =activeRecords;
                          this.foreignDocsCount = this.foreignDocsCount +(activeRecords.length);
                          
                          }
                        

                        }
                  }
                        
                });
              }
            }
            this.updateLoading(false);
            this.petitiondocuments  =_.cloneDeep(this.petitiondocuments);
            this.petitiondocumentr = _.cloneDeep(this.petitiondocumentr);
            this.processingDocuments =false;
            this.updateLoading(false, 'NoDataRef');
            this.updateLoading(false, 'NoDataFoundReforeign');
            setTimeout(()=>{
              self.updateLoading(false, 'NoDataFoundRefu');
              self.updateLoading(false, 'NoDataFoundReforeign');
              self.updateLoading(false, 'NoDataRef');
            },100)
        },
        
        
        init(){
          this.$store.dispatch("getpetition", this.petition._id).then((response) => {
            if (response && response.data && response.data.result ) {
              this.petition = response.data.result;
              // if(_.has(response.data.result, 'petitionerQuestInfo') && this.checkProperty(response.data.result, 'petitionerQuestInfo')){
              //   let petitionerQuestInfo = this.checkProperty(response.data.result, 'petitionerQuestInfo');
              //   this.petition = response.data.result;
              // }
            }
          })
        
        this.documentsUpload = !this.petition.documentsUploadEnabled;
        if (_.has(this.petition, "questionnaireTplId")) {
          this.questionnaireTplId = this.getPetitionDetails["questionnaireTplId"];
          this.getquestionnaireDetails();
        }
        this.splitFiles();
        },
        trashDocument(){
          setTimeout(()=>{
          const $ = JQuery;
         this.tempUpdateDocList=[];
         $("[id^='beneficiaryDocuments_']").each( (i, el)=> {
      //   alert(el.id.substr(4))
           let _id = el.id.substr(21);
         });
    
         let postData = { "petitionId":'', 'docList':[] };
         let processDocuments =(documents ,category='sponsor' )=>{
    
              _.forEach(
              Object.entries(documents),
              (item ,index)=> {
                
                  if( this.checkProperty(item  ,'length')>1){
                  if( this.checkProperty(item[1] ,'length')>0){
                    let documentCategory =item[0];
    
                      let activeRecords = [];
                      _.forEach(item[1] ,(doc)=>{
    
                       let isAlreadyExista = _.find(postData['docList'] ,{'path':doc['path']});
                        if( !this.checkProperty( doc ,'isTrashDocument') && !isAlreadyExista){
                          
                          let docListItem ={
                            "path":doc['path'],
                             "order": 1,
                              "docType": documentCategory,
                              "docTypeOrder": 1,
                              "category": category,
                             // "childrenId": ""
                          }
                          postData['docList'].push(docListItem);
                        }
    
                      })
    
                      
    
                    }
              }
                    
              });
          }
          processDocuments(this.petitiondocuments ,"sponsor");
          if(this.checkProperty(postData ,'docList','length') >0 && this.checkProperty(this.petition ,'_id')  ){
            postData['petitionId'] =this.petition._id;
            let path ="/petition/save-docs-selected-config";
            this.$store.dispatch("commonAction" ,{data:postData,'path':path})
            .then((rx) =>{
                console.log(rx)
            }).catch((err)=>{
                console.log(err)
            })
          }
        } ,10)
        },
        getSavedDocuments(){
         
          let postData ={
            'petitionId':''
          };
          postData['petitionId'] =this.petition._id;
          this.isDocumentsAreSaved =false;
          let path ="/petition/get-docs-selected-config";
           this.$store.dispatch("commonAction" ,{data:postData,'path':path})
           .then((rx) =>{
            if(rx){
              if(this.checkProperty( rx,'docList')){
                this.isDocumentsAreSaved =true;
                this.savedDocumentsList =rx['docList'];
              }else{
                 this.savedDocumentsList=[];
                this.isDocumentsAreSaved =false;
              }
            }else{
              this.savedDocumentsList=[];
              this.isDocumentsAreSaved =false;
            }
            this.init(); 
           }).catch((e)=>{
            this.savedDocuments=[];
            this.isDocumentsAreSaved =false;
            this.init();
           });
        },
        changedDocumentsTab(activeTab='savedDocuments'){
         
          setTimeout(()=>{
            this.documentActiveTab=activeTab
          });
        },
         getquestionnaireDetails() {
          let postData = { questionnaireId: this.questionnaireTplId };
          this.$store
            .dispatch("commonAction", {
              data: postData,
              path: "/questionnaire/details",
            })
            .then((res) => {
              //alert(JSON.stringify(res.name));
              this.questionnaireDetails = res;
              
             
            });
        },
         reloadCaseDetails(){
              
            
                 //this.$store.dispatch("setPetitionTab", 'Case Details').then((res) => {
                      this.openEditDocs(false);
                      this.$store.dispatch("setPetitionTab", 'petitionerDocs')
                       this.$emit("updatepetition" ,'petitionerDocs');
                         
                    
                //  })
               
               
                
         },
      
    
       
        selectMe(){
          let self =this;
          self.selectAll =false
          if(self.checkProperty(self.acceptDocs ,'length') >0){
    
          setTimeout(()=>{
    
            let selectedItems = _.filter(self.acceptDocs,(item)=>{
              return item['accepted'] ==true;
            }) 
            
              
           
            let toTalItemsLength = self.checkProperty(self.petition['documents'],'beneficiaryDocs' ,'length')
    
           let selectedItemsLength= self.checkProperty(selectedItems ,'length');
          
          if(toTalItemsLength >0 && selectedItemsLength>0 &&  (toTalItemsLength ==selectedItemsLength)){
            self.selectAll =true;
           
          }
          if(toTalItemsLength >0 && selectedItemsLength>0){
          //  self.isSelectedForApprove()
          self.isSelectedForApprove=true;
          }
    
    
          } ,10)
        }
          
          // if( this.checkProperty(item ,'accepted')){
          //   item['accepted'] =false;
          // }else{
          //   item['accepted'] =true;
    
          // }
    
        },
     
    
        
        
         checkDocumentsExists(docs){
        //  alert(JSON.stringify(docs))
           if( this.checkProperty( docs ,'length'>0)){
    
              let activeDocs = _.filter(docs,{"status":true});
             // alert(JSON.stringify(activeDocs))
             if(activeDocs){
               return true
             }else{
               return false
             }
    
           }else{
             return true;
           }
         },
        
    
     remove(item, type) {
                type.splice(type.indexOf(item), 1);
                this.removeFileFromS3(item)
                return false;
            },
          filameChenged(fileindex) {
                this.disable_uploadBtn = false;
    
                
                    if (this.uploadFinalMainDocuments.length > 0) {
                        _.forEach(this.uploadFinalMainDocuments, (fl, value) => {
                            //let fname = fl.name;
                            let fname = fl.document.name;
                            fname = fname.trim();
                            
    
                            if (!fname) {
                                this.disable_uploadBtn = true;
                            }
                        });
                    }
             
    
            },
             //uploadMainDocuments
            uploadToS3MainDocuments( docs){
                 docs = docs.map(
                    item =>
                    (item = {
                        name: item.name,
                        file: item.file,
                        document: "",
                        path:'',
                        mimetype: item.type
                    })
                );
    
    
                if (docs.length > 0) {
                    let filIndex = 0;
                    this.fuploder = true;
                    this.disable_uploadBtn = true;
                    docs.forEach(doc => {
                         
                        
                            
                        let formData = new FormData();
                        formData.append("files", doc.file);
                        formData.append("secureType", "private");
                         formData.append("getDetails", true);
                        
                           
                        this.$store.dispatch("uploadS3File", formData).then(response => {
                             filIndex++;
                             if (filIndex >= this.uploadMainDocuments.length) {
                                    this.fuploder = false;
                                    this.disable_uploadBtn = false;
                                }
                            
    
                            response.data.result.forEach(urlGenerated => {
                                //alert(JSON.stringify(urlGenerated));
                                doc.document = urlGenerated;
                                doc.path = urlGenerated;
                               //this.uploadMainDocuments.push(doc);
                               this.uploadFinalMainDocuments.push(doc);
                            });
    
                            
                          
                        });
                    
                        
                    });
                }
    
            },
    
        updateNodataLoading(rel){
          setTimeout(()=>{
            this.updateLoading(false,rel);
            setTimeout(()=>{
            this.updateLoading(false,rel);
          } ,100)
          } ,100)
          return true;
    
        },
        
            
        approveMe(){
    
          let postData = {
                      petitionId: '',
                      beneficiaryDocs:[],
                      typeName:'',
                      subTypeName:''
    
                  
                };
                
                if(this.checkProperty( this.petition ,"typeDetails" ,"name")){
                  postData['typeName'] = this.petition['typeDetails']['name'];
                }
                if(this.checkProperty( this.petition ,"subTypeDetails" ,"name")){
                  postData['subTypeName'] = this.petition['subTypeDetails']['name'];
                }
    
                this.selectedDocsForApprove= _.filter(this.petition.documents['beneficiaryDocs'] ,{"accepted":true})
                    
                if(this.selectedDocsForApprove && this.selectedDocsForApprove.length>0  && _.has( this.petition ,"_id")){
    
                  postData['beneficiaryDocs'] = this.selectedDocsForApprove;
                  postData = Object.assign(postData ,{"petitionId": this.petition._id}); 
                  
                  postData['beneficiaryDocs'] = this.selectedDocsForApprove.map((item)=>{
                    item = Object.assign(item ,{"accepted": true });
                    return item;
                  })
    
                  //approveBenDocuments
    
                  this.fuploder = true;
                  this.disable_uploadBtn = true;
                  let path ="/petition/accept-beneficiary-docs"
                  if(this.checkProperty(this.petition['subTypeDetails'],'id') == 15){
                    path="/perm/accept-beneficiary-docs"
                  }
                  this.$store.dispatch('commonAction', {"data":postData ,path}).then(response => {
                        this.showToster({message:response.message ,isError:false })
                        this.fileuploadPopup = false;
                        this.fuploder = false;
                        this.disable_uploadBtn = false;
                        this.fileuploadPopup = false;
                     
                      setTimeout(()=>{  this.$emit("updatepetition" ,'petitionerDocs'); } ,100);
    
                  
                  })
                  .catch((error) => {
                      Object.assign(this.formerrors ,{'msg':error})
                       this.showToster({message:error ,isError:true })
                      this.fuploder = false;
                      this.disable_uploadBtn = false;
                  });
    
    
          }
    
        },
    
        uploadBenDocuments() {
               
                 
                 Object.assign( this.formerrors ,{ msg:''})
                if (this.disable_uploadBtn) {
                    return false;
                }
               // this.fileuploadPopup = false; /petition/upload-beneficiary-docs,
                let postData = {
                      petitionId: '',
                      beneficiaryDocs:[],
                      typeName:'',
                      subTypeName:''
    
                  
                };
                
                if(this.checkProperty( this.petition ,"typeDetails" ,"name")){
                  postData['typeName'] = this.petition['typeDetails']['name'];
                }
                if(this.checkProperty( this.petition ,"subTypeDetails" ,"name")){
                  postData['subTypeName'] = this.petition['subTypeDetails']['name'];
                }
                    
                if(this.uploadFinalMainDocuments && this.uploadFinalMainDocuments.length>0  && _.has( this.petition ,"_id")){
    
    
                   if(this.uploadFinalMainDocuments.length>0){
    
                        this.uploadFinalMainDocuments.forEach((doc)=>{
                           
                            // let document = doc.document
                            // document = Object.assign(document ,{ name:doc.name})
                            let document = doc
                             postData['beneficiaryDocs'].push(document);
                        })
                       
    
                    
    
                  postData['beneficiaryDocs'] = postData['beneficiaryDocs'].map((item)=>{
                    item.accepted =false;
                    return item;
    
                  });
                  //petition.documents['beneficiaryDocs']
                  if(this.checkProperty( this.petition ,"documents" ,"beneficiaryDocs") && (this.petition.documents['beneficiaryDocs'].length>0 )){
                    _.forEach( this.petition.documents['beneficiaryDocs'], (item)=>{
                      postData['beneficiaryDocs'].push(item);
    
                    })
    
                  }
                  postData = Object.assign(postData ,{"petitionId": this.petition._id});  
                  
                  this.fuploder = true;
                  this.disable_uploadBtn = true;
                  let path ="/petition/upload-beneficiary-docs"
                  if(this.checkProperty(this.petition['subTypeDetails'],'id') == 15){
                    path="/perm/upload-beneficiary-docs"
                  }
                  //"uploadBenDocuments", postData
                 
                  this.$store.dispatch('commonAction', {"data":postData ,path}).then(response => {
                        this.showToster({message:response.message ,isError:false })
                        this.fileuploadPopup = false;
                        this.fuploder = false;
                        this.disable_uploadBtn = false;
                        this.fileuploadPopup = false;
                     
                      setTimeout(()=>{
                        this.$store.dispatch("setPetitionTab" , '').then(()=>{
                          this.$emit("updatepetition" ,'petitionerDocs');
    
                        }).catch(()=>{
                          this.$emit("updatepetition" ,'petitionerDocs');
    
                        })
                         
                         
                              
                              
                          } ,100);
    
                  
                  })
                  .catch((error) => {
                      Object.assign(this.formerrors ,{'msg':error})
                      this.fuploder = false;
                      this.disable_uploadBtn = false;
                  });
            
             }
              }else{
                Object.assign( this.formerrors ,{ msg:'Upload atleast one document'})
    
          }
        
             
           
        },
    
        selectedDocuments(docs) {
               
                docs = docs.map(
                    item =>
                    (item = {
                        name: item.name,
                        file: item.file,
                        extn: "",
                        path:'',
                        mimetype: item.type,
                        accepted:false,
                    })
                );
                this.documentUploaded = [];
                this.documentUploaded = docs;
                this.fuploder = false;
                this.disable_uploadBtn = false;
                if (docs.length > 0) {
                    let filIndex = 0;
                    this.fuploder = true;
                    this.disable_uploadBtn = true;
                    this.documentUploaded.forEach(doc => {
                         
                         
                             
                        let formData = new FormData();
                        formData.append("files", doc.file);
                        formData.append("secureType", "private");
                         formData.append("getDetails", true);
                        
                           
                        this.$store.dispatch("uploadS3File", formData).then(response => {
                             filIndex++;
                             if (filIndex >= this.documentUploaded.length) {
                                    this.fuploder = false;
                                    this.disable_uploadBtn = false;
                                }
                          
    
                            response.data.result.forEach(urlGenerated => {
                                
                                 doc.path = urlGenerated.path;
                                 doc.extn = urlGenerated.extn;
                                 delete doc.file
                            });
    
                            
                          
                        });
                   
                        
                    });
                }
                this.fileuploadPopup = true
            },
         remove_uploadedfile( fileindex) {
                
                this.documentUploaded.splice(fileindex, 1);
    
                if(this.documentUploaded.length ==0){
                  this.fileuploadPopup =false;
    
                }
            },
         fileNameChenged( fileindex) {
                this.disable_uploadBtn = false;
    
                
                    if (this.documentUploaded.length > 0) {
                        _.forEach(this.documentUploaded, (fl, index) => {
                          if(index ==fileindex){
                            //let fname = fl.name;
                            let fname = fl.name;
                            fname = fname.trim();
    
                            if (!fname) {
                                this.disable_uploadBtn = true;
                            }
                        }
    
                        });
                    }
               
    
            },
        changeTab(tabName=''){
    
          this.selectAll =false;
          
          //this.initDocuments();
          this.activeTabName = tabName;
          this.openEditDocs(false);
            setTimeout(()=>{
    
               this.updateNodataLoading()
            } , 100)
       
        },
        
        selectDoctype(type = "") {
          this.uploaddocType = type;
        },
    
        upload(model, uploaddocType) {
          this.is_enablesavebtn = false;
          
          let temp_count = 0;
          this.uploaddocType = uploaddocType;
          let formData = new FormData();
          if (model.length > 0) {
            this.$vs.loading();
            model.forEach((doc) => {
              formData.append("files", doc.file);
              formData.append("secureType", "public");
              this.$store.dispatch("uploadS3File", formData).then((response) => {
               temp_count++;
                let docmnt = {
                  mimetype: model[0]["file"]["type"],
                  name: model[0]["file"]["name"],
                  status: true,
                  uploadedOn: new Date(),
                  url: response["data"]["result"][0],
                  path: response["data"]["result"][0],
                  tempDoc:true,
                  uploadedBy:this.checkProperty(this.getUserData,'userId'),
                  uploadedByName:this.checkProperty(this.getUserData,'name'),
                  uploadedByRoleId:this.getUserRoleId,
                  uploadedByRoleName:this.checkProperty(this.getUserData,'loginRoleName'),
                };
    
                this.petition["documents"][this.uploaddocType].push(docmnt);
                this.is_enablesavebtn = true;
                if (temp_count >= model.length) {
                     
                      this.$vs.loading.close();
                  }
              });
            });
          }
        },
    
        saveUploadedsFiles() {
          var postpetition = {
            petitionId: this.$route.params.itemId,
            userName: this.$store.state.user.name,
            action: "UPLOAD_DOCUMENTS",
            documents: this.petition["documents"],
            typeName: this.petition["subTypeDetails"]["name"],
            subTypeName: this.petition["typeDetails"]["name"],
          };
    
    
    
          this.$store
            .dispatch("petitioner/petitionupdate", postpetition)
    
            .then((response) => {
              if (response.error) {
                Object.assign(this.formerrors, {
                  msg: response.error.message,
                });
              } else {
                this.is_enablesavebtn = false;
                this.$emit("updatepetition" ,'petitionerDocs');
                this.$vs.notify({
                  text: response.message,
                  position: "top-right",
                  color: "primary",
                  
                });
              }
            });
        },
        removethis(index,parent) {
          
          parent.splice(index, 1);
          this.trashDocument()
          return false;
          
        },
       
        successUpload() {
          this.$vs.notify({
            color: "success",        
            position: "top-right",
            color: "primary",
            text: "Documents Sucessfully Uploded",
          });
        },
        showMessages(message) {
          this.$vs.notify({
            title: "Success",
            position: "top-right",
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
            text: message,
          });
        },
        downloadallfile() {
            this.filesDownloading =false;
            this.downloadDocList = true;
            this.downloadDocumentPop = true;
            setTimeout(()=>{
              this.changedDocumentsTab('savedDocuments');
            });
         
        },
        downloadcombine() {
         let _APIURL = this.$globalgonfig._APIURL
          var self = this;
          var docs = [];
    
    
        let combailDocuments = (documents)=>{
            _.forEach(documents ,(doc)=> {
    
              if(this.checkProperty(doc ,'length') >1){
                if(this.checkProperty(doc[1] ,'length') >0){
               
                doc[1].forEach(i=> {
                      if(i.path!=null && i.path !='' && !this.checkProperty(i ,'isTrashDocument')   ){ 
                        docs.push(i.path);
                      }else if(i.url!=null && i.url !='' && !this.checkProperty(i ,'isTrashDocument')  ){ 
                        docs.push(i.url);
                      }
                })
              }
              }
            })
        }
        combailDocuments(this.petitiondocuments );
        combailDocuments(this.petitiondocumentr );
           
             
            this.childernDocuments.forEach((child)=>{
    
               child.forEach(doc=> {
               doc[1].forEach(i=> {
                    if(i.path !='' && i.path!=null && !this.checkProperty(i ,'isTrashDocument') ){ 
                      docs.push(i.path);
                    }else if(i.url !='' && i.url!=null && !this.checkProperty(i ,'isTrashDocument') ){ 
                      docs.push(i.url);
                    }
               })
            })
    
    
            })
           
    
                  let postdata = {
            petitionId: this.petition._id,
            documents: docs,
          };
         
          
          if(postdata['documents'].length>0){
              this.filesDownloading =true;
            this.$store
            .dispatch("downloaddocsbyorder", postdata)
            .then((response) => {
               this.filesDownloading =false;
           
              self.downloadDocumentPop = true;
             // alert( _APIURL+"/common/viewfile?path="+response.data.result.path);
              window.open(
                _APIURL+"/common/viewfile?path=" +
                  response.data.result.path,
                "_blank"
              );
            }).catch((error)=>{
              this.filesDownloading =false;
              this.showToster({ message:error , isError: true})
             
            });
        
          } 
        },
        downloadfile(value, download = false, viewmode = true) {
          value.download = download;
         // value.viewmode = viewmode;
          if(_.has(value ,"url" ) && !(_.has(value ,"path" ) )){
            value =Object.assign(value ,{ "path":value['url']})
          }else  if(_.has(value ,"path" ) && !(_.has(value ,"url" )) ){
            value =Object.assign(value ,{ "url":value['path']})
          }
          //alert(value.viewmode)
          this.$emit('download_or_view' ,value);
          // value.url = value.url.replace(this.$globalgonfig._S3URL,"");
          // value.url = value.url.replace(this.$globalgonfig._S3URLAWS,"");
          // let postdata = { keyName: value.url };
          // this.$store.dispatch("getSignedUrl", postdata).then((response) => {
          //   window.open(response.data.result.data, "_blank");
          // });  ({'field':field , 'dataVar':beneficiaryInfo})
        },
      },
      computed:{
        IsSponsorLogin(){
      let returnVal =false;
      let loginUserData = this.$store.state.loginUserData;
      if(this.checkProperty(loginUserData,'accountType') && this.checkProperty(loginUserData,'accountType')=='Individual' 
       && this.checkProperty(loginUserData,'accountSubType') && this.checkProperty(loginUserData,'accountSubType')=='Sponsor'){
        returnVal =true
      }else{
        returnVal =false
      }
    return returnVal;   
    },
        isSelectedForApprove(){
     let selectedItems= _.filter(this.acceptDocs,{"accepted":true})
     if(selectedItems && selectedItems.length>0){
       return true;
     }else{
       return false;

     }
    },
       checkDocumentPath(){
        return (data)=>{
    
        }
       },
        checkNoNotifyUserIds(){
          let returnValue =true;
          if(_.has(this.petition, 'noNotifyUserIds')  ){
            if(this.petition['noNotifyUserIds'].length>0){
              if(this.petition['noNotifyUserIds'].indexOf(this.getUserData['userId']) >-1){
                returnValue = false;
              }
    
            }
    
          }
          return returnValue;
        },
        //5--front office user
        checkApproveDocuments(){
          let returnVal = false;
          
          let docSupList = _.find(this.workFlowDetails.config, {
            code: "SUPERVISOR_LIST",
          });
          if (docSupList && docSupList.editors) {
            this.finalList = _.map(docSupList.editors, "roleId");
          }
          if(this.finalList && this.finalList.indexOf( this.getUserRoleId)>-1 || [5].indexOf(this.getUserRoleId)>-1) {
            returnVal = true;
          }
          
          return returnVal;
        },
    
        
        getbenficiarySavedDocuments(){
         
          let returnSavedDocuments =[];
          _.forEach(Object.entries(this.petitiondocuments) , (category ,index)=>{
           
            if(this.checkProperty(category ,'length')>1){
              if(this.checkProperty(category[1] ,'length') >0){
                let trashedItems = _.filter(category[1] ,{'isTrashDocument':false});
               
                if(trashedItems && this.checkProperty(trashedItems ,'length')>0){
                 
                  returnSavedDocuments.push(category);
                }
    
              }
              //isTrashDocument
           
    
            }
    
          });
          return returnSavedDocuments
         
         
        },
        getbenficiaryTrashedDocuments(){
         
          let returnSavedDocuments =[];
          _.forEach(Object.entries(this.petitiondocuments) , (category ,index)=>{
           
            if(this.checkProperty(category ,'length')>1){
              if(this.checkProperty(category[1] ,'length') >0){
                let trashedItems = _.filter(category[1] ,{'isTrashDocument':true});
               
                if(trashedItems && this.checkProperty(trashedItems ,'length')>0){
                 
                  returnSavedDocuments.push(category);
                }
    
              }
              //isTrashDocument
           
    
            }
    
          });
         
          return returnSavedDocuments
         
         
        },
    
        
        getspouseSavedDocuments(){
          //this.petitiondocumentr
           let returnSavedDocuments =[];
          _.forEach(Object.entries(this.petitiondocumentr) , (category ,index)=>{
           
            if(this.checkProperty(category ,'length')>1){
              if(this.checkProperty(category[1] ,'length') >0){
                let trashedItems = _.filter(category[1] ,{'isTrashDocument':false});
               
                if( this.checkProperty(trashedItems ,'length')>0){
                 
                  returnSavedDocuments.push(category);
                }
    
              }
              //isTrashDocument
           
    
            }
    
          });
          return returnSavedDocuments
         
    
        },
        getspouseTrashedDocuments(){
          //this.petitiondocumentr
           let returnSavedDocuments =[];
          _.forEach(Object.entries(this.petitiondocumentr) , (category ,index)=>{
           
            if(this.checkProperty(category ,'length')>1){
              if(this.checkProperty(category[1] ,'length') >0){
                let trashedItems = _.filter(category[1] ,{'isTrashDocument':true});
               
                if(trashedItems && this.checkProperty(trashedItems ,'length')>0){
                 
                  returnSavedDocuments.push(category);
                }
    
              }
              //isTrashDocument
           
    
            }
    
          });
          return returnSavedDocuments
         
    
        },
        
        //childernDocuments
        getChildSavedDocuments(){
    
          
          //this.petitiondocumentr
            let finalArray =[];
           _.forEach(this.childernDocuments ,(child ,index)=>{
             
             let returnSavedDocuments =[];
          _.forEach(Object.entries(child) , (category ,index)=>{
           
            if(this.checkProperty(category ,'length')>1){
              if(this.checkProperty(category[1] ,'length') >0){
                let trashedItems = _.filter(category[1][1] ,{'isTrashDocument':false});
               
                if( this.checkProperty(trashedItems ,'length')>0){
                 
                  returnSavedDocuments.push(category[1]);
               }
    
              }
              //isTrashDocument
           
    
            }
    
          });
         
    
          if(this.checkProperty(returnSavedDocuments ,'length')>0){
            finalArray.push(returnSavedDocuments)
          }
    
    
        })
          return finalArray
         
    
        },
        getChildTrasheddDocuments(){
    
          
    
          
          //this.petitiondocumentr
            let finalArray =[];
           _.forEach(this.childernDocuments ,(child ,index)=>{
             
             let returnSavedDocuments =[];
          _.forEach(Object.entries(child) , (category ,index)=>{
           
            if(this.checkProperty(category ,'length')>1){
              if(this.checkProperty(category[1] ,'length') >0){
                let trashedItems = _.filter(category[1][1] ,{'isTrashDocument':true});
               
                if( this.checkProperty(trashedItems ,'length')>0){
                 
                  returnSavedDocuments.push(category[1]);
               }
    
              }
              //isTrashDocument
           
    
            }
    
          });
         
    
          if(this.checkProperty(returnSavedDocuments ,'length')>0){
            finalArray.push(returnSavedDocuments)
          }
    
    
        })
          return finalArray
    
        },
       
      }
    };
    </script>
    